export default __webpack_public_path__ + "static/TSG-Shield-97a3601d54216f21b56def0a15471c6b.svg";